import { h, render } from 'preact'
import { NfcApp } from './nfc-app'

render(<NfcApp />, document.getElementById('nfcApp'))
